var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mock-exam"},[_c('div',{staticClass:"question-container"},[_c('div',{staticClass:"left"},[_c('div',{staticClass:"answer-sheet"},[_c('div',{staticClass:"sheet-title"},[_vm._v(" 答题卡 ")]),_c('div',{staticClass:"question-sheet"},_vm._l((_vm.questionList),function(question,queIdx){return _c('div',{key:queIdx,class:[
              { 'question-idx': true },
              { 'current-question': queIdx === _vm.currentQuestionIdx },
              {
                'answered-question':
                  _vm.userAnswerList[queIdx]['answer'].length !== 0
              },
              { 'last-in-row': (queIdx + 1) % 6 === 0 }
            ],on:{"click":function($event){return _vm.jump2Question(queIdx)}}},[_vm._v(" "+_vm._s(queIdx + 1)+" ")])}),0)])]),_c('div',{staticClass:"right"},[_c('div',{staticClass:"exam-title"},[_c('div',{staticClass:"current-question-idx"},[_vm._v(_vm._s(_vm.currentQuestionIdx + 1))]),_c('div',{staticClass:"exam-name"},[_vm._v(_vm._s(_vm.$route.query.packageExamName))]),_c('div',{staticClass:"question-idx"},[_vm._v(" "+_vm._s(_vm.currentQuestionIdx + 1)+"/"+_vm._s(_vm.questionList.length)+" ")])]),_c('div',{staticClass:"question"},[_c('div',{staticClass:"question-title"},[_c('div',{staticClass:"question-type"},[_vm._v(" "+_vm._s(_vm.currentQuestion.type === 0 ? "单选题" : "多选题")+" ")]),_c('div',{staticClass:"question-title-content",domProps:{"innerHTML":_vm._s(_vm.currentQuestion.content)}})]),_c('div',{staticClass:"question-options"},_vm._l((_vm.currentQuestion.optionList),function(option,index){return _c('div',{key:index,staticClass:"option",on:{"click":function($event){return _vm.answer_question(option.sort)}}},[_c('div',{class:[
                { 'option-idx': true },
                {
                  'selected-option-idx':
                    _vm.currentQuestion.type === 0
                      ? false
                      : option.isSelected &&
                        _vm.userAnswerList[_vm.currentQuestionIdx] === -1
                },
                {
                  'correct-option-idx':
                    _vm.currentQuestion.type === 0
                      ? option.isSelected && option.isCorrect
                      : _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isSelected &&
                        option.isCorrect
                },
                {
                  'wrong-option-idx':
                    _vm.currentQuestion.type === 0
                      ? option.isSelected && !option.isCorrect
                      : _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isSelected &&
                        !option.isCorrect
                },
                {
                  'blank-correct-option-idx':
                    _vm.currentQuestion.type === 0
                      ? _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isCorrect &&
                        !option.isSelected
                      : _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isCorrect &&
                        !option.isSelected
                }
              ]},[_vm._v(" "+_vm._s(option.sort)+" ")]),_c('div',{class:[
                { 'option-content': true },
                {
                  'selected-option-content':
                    _vm.currentQuestion.type === 0
                      ? false
                      : option.isSelected &&
                        _vm.userAnswerList[_vm.currentQuestionIdx] === -1
                },
                {
                  'correct-option-content':
                    _vm.currentQuestion.type === 0
                      ? option.isSelected && option.isCorrect
                      : _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isSelected &&
                        option.isCorrect
                },
                {
                  'wrong-option-content':
                    _vm.currentQuestion.type === 0
                      ? option.isSelected && !option.isCorrect
                      : _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isSelected &&
                        !option.isCorrect
                },
                {
                  'blank-correct-option-content':
                    _vm.currentQuestion.type === 0
                      ? _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isCorrect &&
                        !option.isSelected
                      : _vm.userAnswerList[_vm.currentQuestionIdx] !== -1 &&
                        option.isCorrect &&
                        !option.isSelected
                }
              ]},[_vm._v(" "+_vm._s(option.content)+" ")])])}),0)]),_c('div',{staticClass:"analysis"},[_c('div',{staticClass:"analysis-answer"},[_vm._v(" 正确答案"),_c('span',[_vm._v(_vm._s(_vm.curAnswer))])]),_c('div',{staticClass:"analysis-data"},[_vm._v(" 考题数据"),_c('span',[_vm._v("此题的正确率为"+_vm._s((_vm.currentQuestion.answerNum === 0 ? 0 : (_vm.currentQuestion.correctNum / _vm.currentQuestion.answerNum) * 100 ).toFixed(2))+"%")])]),_c('div',{staticClass:"analysis-detail"},[_c('div',{staticClass:"analysis-detail-title"},[_vm._v("试题解析")]),_c('div',{staticClass:"analysis-detail-content",domProps:{"innerHTML":_vm._s(_vm.currentQuestion.analysis)}})])]),_c('div',{staticClass:"btns"},[_c('div',{staticClass:"next-btn",class:{
            'disabled-btn': _vm.currentQuestionIdx === _vm.questionList.length - 1
          },on:{"click":function($event){return _vm.next_question()}}},[_vm._v(" 下一题 ")]),_c('div',{staticClass:"preview-btn",class:{ 'disabled-btn': _vm.currentQuestionIdx === 0 },on:{"click":function($event){return _vm.previous_question()}}},[_vm._v(" 上一题 ")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }